import { IconLibrary } from '../library';
import { getBasePath } from '../../../../utilities/base-path';

// @todo: This doesn't work with the combination of Storybook, local WDS server, and external consumers.
const library: IconLibrary = {
  name: 'custom',
  resolver: name => `${getBasePath()}/assets/svg/custom/${name}.svg`,
};

export default library;
